import { render, staticRenderFns } from "./CustomerServiceBenefit.vue?vue&type=template&id=44df1529&scoped=true&"
import script from "./CustomerServiceBenefit.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceBenefit.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceBenefit.vue?vue&type=style&index=0&id=44df1529&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44df1529",
  null
  
)

export default component.exports